import router from './router'
import store from './store/store'
import { Message } from 'element-ui'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'


NProgress.configure({ showSpinner: false })

const whiteList = ['/login', '/register']

router.beforeEach((to, from, next) => {
  console.log(router)
  NProgress.start()
  let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : null
  if (token) {
    /* has token*/
    console.log(to.path)
    if (to.path === '/login') {
      next({ path: '/home' })
      NProgress.done()
    } else {
      if (!store.getters.studentShow) {
        store.dispatch('studentInformation')
      }
      next()
    }
  } else {
    // 没有token
    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js